import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class PatisserieBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.PATISSERIE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default PatisserieBuildingTileEntity;
